import { render, staticRenderFns } from "./SharedLinkRestoreFolder.vue?vue&type=template&id=08f6285d&scoped=true&"
import script from "./SharedLinkRestoreFolder.vue?vue&type=script&lang=js&"
export * from "./SharedLinkRestoreFolder.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkRestoreFolder.vue?vue&type=style&index=0&id=08f6285d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6285d",
  null
  
)

export default component.exports